import {PrimaryButton, SharedColors} from "@fluentui/react";
import {Link} from "react-router-dom";
import * as React from "react";

function ProjectLink(item) {
    let color = SharedColors.cyanBlue10;
    if (item.transaction_number !== null) {
        color = SharedColors.yellowGreen10;
    } else if (item.reservation_number !== null) {
        color = SharedColors.greenCyan10;
    } else if (item.reserved_until !== null) {
        color = SharedColors.cyan10;
    }
    return (<Link to={`/project/${item.id}`}><PrimaryButton styles={{root: {backgroundColor: color, borderColor: color}, rootHovered: {backgroundColor: color, borderColor: color}}} text={item.name} /></Link>);
}

export default ProjectLink;